// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kStv","colBig":"styles_colBig__3c-FG","colSmall":"styles_colSmall__1UPP7"};